import { ChakraComponents as CC } from '@Modules/core/lib/chakra';
import IndexFormHandler from '@Modules/terminalManagementSystem/merchant/containers/formHandlers/merchantRequest/index/IndexFormHandler';
import AddressFormHandler from '@Modules/terminalManagementSystem/merchant/containers/formHandlers/merchantRequest/address/AddressFormHandler';
import ClientFormHandler from '@Modules/terminalManagementSystem/merchant/containers/formHandlers/merchantRequest/client/ClientFormHandler';
import OwnerFormHandler from '@Modules/terminalManagementSystem/merchant/containers/formHandlers/merchantRequest/owner/OwnerFormHandler';
import RequestFormHandler from '@Modules/terminalManagementSystem/merchant/containers/formHandlers/merchantRequest/request/RequestFormHandler';


export default function AnonymousCardProduction() {
  return (
    <>
      <CC.Box>
        <CC.Text fontSize={20} fontWeight="bold" mb="4">
        Demande commerçant
        </CC.Text>
        <IndexFormHandler />
      </CC.Box>
      <CC.Tabs>
        <div style={{overflow: 'auto'}}>
          <CC.TabList>
            <CC.Tab minWidth={'fit-content'}>Client</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Proprietaire</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Adresse</CC.Tab>
            <CC.Tab minWidth={'fit-content'}>Demande</CC.Tab>
          </CC.TabList>
        </div>

        <CC.TabPanels>
          <CC.TabPanel>
            <ClientFormHandler />
          </CC.TabPanel>
          <CC.TabPanel>
            <OwnerFormHandler />
          </CC.TabPanel>
          <CC.TabPanel>
            <AddressFormHandler />
          </CC.TabPanel>
          <CC.TabPanel>
            <RequestFormHandler />
          </CC.TabPanel>
        </CC.TabPanels>
    </CC.Tabs>
    </>
  );
}